import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import JoinUs from "../views/JoinUs.vue";
import TourView from "../views/TourView.vue";
import AccommodationView from "../views/AccommodationView.vue";
import CheckoutView from "../views/CheckoutView.vue";
import DocumentUploadView from "../views/DocumentUploadView.vue";
// import ExhibitorView from "../views/ExhibitorView.vue"; // route disabled
import SponsorshipView from "../views/SponsorshipView.vue";
import PartnersView from "../views/PartnersView.vue";
import TourRegistrationView from "../views/TourRegistrationView.vue";
import SpeakersView from "../views/SpeakersView.vue";
import AgendaView from "../views/AgendaView.vue";
import ContactView from "../views/ContactView.vue";
import VisaView from "../views/VisaView.vue";
import TravelView from "../views/TravelView.vue";
import NotFoundView from "../views/NotFoundView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/registration",
    name: "joinus",
    component: JoinUs,
  },
  {
    path: "/checkout",
    name: "checkout",
    component: CheckoutView,
  },
  {
    path: "/documents",
    name: "documents",
    component: DocumentUploadView,
  },
  {
    path: "/tour",
    name: "tour",
    component: TourView,
  },
  {
    path: "/tour-registration",
    name: "tour-registration",
    component: TourRegistrationView,
  },
  {
    path: "/accommodation",
    name: "accommodation",
    component: AccommodationView,
  },
  // {
  //   path: "/exhibitor",
  //   name: "exhibitor",
  //   component: ExhibitorView,
  // },
  {
    path: "/sponsorship",
    name: "sponsorship",
    component: SponsorshipView,
  },
  {
    path: "/partners",
    name: "partners",
    component: PartnersView,
  },
  {
    path: "/speakers",
    name: "speakers",
    component: SpeakersView,
  },
  {
    path: "/agenda",
    name: "agenda",
    component: AgendaView,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/visa",
    name: "visa",
    component: VisaView,
  },
  {
    path: "/travel",
    name: "travel",
    component: TravelView,
  },
  // Catch all other routes and show 404 page
  {
    path: "/:pathMatch(.*)*",
    name: "notfound",
    component: NotFoundView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    } else {
      return { top: 0 };
    }
  },
});

export default router;
